import { FlexContainer, FlexItem, MainContainer } from '@astrumu/ui-library';
import { FunctionComponent } from 'react';
import { GoalsSkeleton } from '../Goals/Skeleton';

export const IntroductionSkeleton: FunctionComponent = () => (
  <MainContainer>
    <FlexContainer
      style={{
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10
      }}
    >
      <FlexItem
        style={theme => ({
          animation: 'ga-opacity 1s steps(5, end) infinite',
          maxWidth: '50%',
          margin: 'auto',
          borderRadius: 5,
          width: '100%',
          height: 7,
          background: theme.contourColor
        })}
      />

      <FlexItem
        style={theme => ({
          animation: 'ga-opacity 1s steps(5, end) infinite',
          maxWidth: '30%',
          margin: 'auto',
          borderRadius: 5,
          width: '100%',
          height: 7,
          background: theme.contourColor
        })}
      />
    </FlexContainer>

    <GoalsSkeleton itemsCount={5} />

    <FlexContainer
      style={{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10
      }}
    >
      <FlexItem
        style={theme => ({
          width: 300,
          height: 300,
          borderRadius: '100%',
          background: theme.primaryBackgroundColor,
          border: `3px dotted ${theme.contourColor}`
        })}
      />
    </FlexContainer>

    <GoalsSkeleton itemsCount={5} />
  </MainContainer>
);
